export default "__VITE_ASSET__20e6b30c__"